import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Loader from "@amzn/meridian/loader";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import Column from "@amzn/meridian/column";
import {
    chainWalk,
    convertToString,
    formQueryParams,
    getFilteredLocations, getNodeId,
    isCapabilityARorSSD
} from "../Utility";
import Link from "@amzn/meridian/link";
import {FormattedMessage} from "react-intl";
import {PackageStatus} from "../enums";
import Input from "@amzn/meridian/input";
import {getLocale} from "../handler/LocaleHandler";
import {getDocumentURL} from "../handler/ParentDataHandler";
import {NOT_AVAILABLE} from "../constants";
import RefreshTimer from "./RefreshTimer";

class Route extends Component {

    constructor(props) {
        super(props);
        this.state = {
            routeCodePrefixes: props.routeCodePrefixesFromUrl,
            sortColumn: "routeCode",
            sortDirection: "ascending"
        }
    }

    getFilteredRoutes(routes, plannedPackageMetricsMap, stowPackageMetricsMap, routeCodePrefixList) {
        const prefixFiltered = routes.filter(routeId => {
            const routeCode = plannedPackageMetricsMap[routeId].routeCode.toUpperCase();
            if (routeCode && routeCodePrefixList.length === 0){
                return true;
            }
            return routeCodePrefixList.find(routeCodePrefix => routeCode.startsWith((routeCodePrefix).toUpperCase()));
        })

        return getFilteredLocations(prefixFiltered, stowPackageMetricsMap, false);
    }

    render() {
        const {
            loading, plannedPackageMetricsMap, stowPackageMetricsMap, capability
        } = this.props;

        const routes = Object.keys(plannedPackageMetricsMap);
        const isAssociateMetricViewEnabled = !isCapabilityARorSSD(capability);
        const isRouteDetailsEnabled = isCapabilityARorSSD(capability);
        const routeCodePrefixList = this.state.routeCodePrefixes.split(",").map(routeCode => routeCode.trim()).filter(routeCode => routeCode !== "");

        const filteredRoutes = this.getFilteredRoutes(routes, plannedPackageMetricsMap, stowPackageMetricsMap, routeCodePrefixList);
        const onSort = (sortDetails) => {
            this.setState({
                sortColumn: sortDetails.sortColumn,
                sortDirection: sortDetails.sortDirection
            })
        }

        function customCompare(a, b) {
            return convertToString(a)
                .localeCompare(convertToString(b), getLocale(), {numeric: true});
        }

        const sortColumn = this.state.sortColumn;
        const direction = this.state.sortDirection;
        filteredRoutes.sort((r1, r2) => {
            const r1CombinedMetricsMap = this.getCombinedMetricsMap(r1);
            const r2CombinedMetricsMap = this.getCombinedMetricsMap(r2);
            if (direction === "ascending") {
                return customCompare(r1CombinedMetricsMap[sortColumn], r2CombinedMetricsMap[sortColumn])
            } else {
                return customCompare(r2CombinedMetricsMap[sortColumn], r1CombinedMetricsMap[sortColumn])
            }
        });

        if (loading && !routes.length) {
            return (
                <Column
                    height="400px"
                    alignmentHorizontal="center"
                >
                    <Loader/>
                </Column>
            );
        }

        return (
            <Column>
                <Column width="30%" minWidth="300px">
                    <Input type="text"
                           size="small"
                           autoFocus={true}
                           placeholder="Filter by prefix ..."
                           prefix="Route Code"
                           value={this.state.routeCodePrefixes}
                           onChange={routeCodePrefixes => this.routeCodePrefixChanged(routeCodePrefixes)}
                    />
                </Column>
                <RefreshTimer deps={[stowPackageMetricsMap]} />
                <Table headerRows={2} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}
                       sortColumn={this.state.sortColumn}
                       sortDirection={this.state.sortDirection}
                       onSort={onSort}>
                    {this.renderHeadings(isAssociateMetricViewEnabled)}
                    {this.renderSubHeadings(isAssociateMetricViewEnabled)}
                    {filteredRoutes.map((route) => this.renderRouteRow(route, isAssociateMetricViewEnabled, isRouteDetailsEnabled))}
                </Table>
            </Column>
        )
    }

    routeCodePrefixChanged(routeCodePrefixes) {
        this.setState(() => {
            return {
                routeCodePrefixes: routeCodePrefixes
            }
        })
    }

    renderHeadings(isAssociateMetricViewEnabled) {
        return (
            <TableRow>
                <TableCell/>
                <TableCell>
                    {/*
                    TODO: Pull common strings such as Packages out of specific categories such as cluster.
                    Using the same for now
                    */}
                    <FormattedMessage id="cluster.packages" defaultMessage="Packages"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="cluster.performance" defaultMessage="Performance"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                {isAssociateMetricViewEnabled ? <TableCell>
                    <FormattedMessage id="cluster.stowers" defaultMessage="Stowers"/>
                </TableCell> : null}
                <TableCell/>
            </TableRow>
        )
    }

    renderSubHeadings(isAssociateMetricViewEnabled) {
        return (
            <TableRow>
                <TableCell sortColumn="routeCode">
                    <FormattedMessage id="route.route" defaultMessage="Route"/>
                </TableCell>
                <TableCell sortColumn="plannedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="route.route_planned" defaultMessage="R. Planned"/>
                </TableCell>
                <TableCell sortColumn="currentInductedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell sortColumn="stowedPackages" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.stowed" defaultMessage="Stowed"/>
                </TableCell>
                <TableCell sortColumn="stowVsPlan" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.stow_plan" defaultMessage="Stow/Plan"/>
                </TableCell>
                <TableCell sortColumn="problemSolvePackages" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.ps" defaultMessage="PS"/>
                </TableCell>
                <TableCell sortColumn="fsaf" alignmentHorizontal="right">
                    <FormattedMessage id="aisle.fsaf" defaultMessage="FSAF"/>
                </TableCell>
                <TableCell sortColumn="stowRate" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.stow_rate" defaultMessage="Stow rate"/>
                </TableCell>
                <TableCell sortColumn="scanCompliance" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.scan_complaince" defaultMessage="Scan comp."/>
                </TableCell>
                {isAssociateMetricViewEnabled ? <TableCell sortColumn="activeStowers" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.active" defaultMessage="Active"/>
                </TableCell> : null}
                {isAssociateMetricViewEnabled ? <TableCell sortColumn="inactiveStowers" alignmentHorizontal="right">
                    <FormattedMessage id="cluster.inactive" defaultMessage="Inactive"/>
                </TableCell> : null}
            </TableRow>
        )
    }

    renderRouteRow(routeId, isAssociateMetricViewEnabled, isRouteDetailsEnabled) {
        const combinedMetricsMap = this.getCombinedMetricsMap(routeId)

        return (
            <TableRow key={routeId}>
                <TableCell>{(isRouteDetailsEnabled) ? <Link onClick={() => {
                    this.onRouteClick(routeId, combinedMetricsMap.routeCode)
                }} type="secondary">{combinedMetricsMap.routeCode}</Link> : combinedMetricsMap.routeCode}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.plannedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderClickableCount(combinedMetricsMap.currentInductedPackages, PackageStatus.CURRENT_INDUCTED, routeId)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderClickableCount(combinedMetricsMap.stowedPackages, PackageStatus.STOWED, routeId)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowVsPlan}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderClickableCount(combinedMetricsMap.problemSolvePackages, PackageStatus.PROBLEM_SOLVE, routeId)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.fsaf}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowRate}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.scanCompliance}%
                </TableCell>
                {isAssociateMetricViewEnabled ? <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.activeStowers}
                </TableCell> : null}
                {isAssociateMetricViewEnabled ? <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.inactiveStowers}
                </TableCell> : null}
            </TableRow>
        )
    }

    getCombinedMetricsMap = routeId => {
        const {
            stowPackageMetricsMap, inductPackageMetricsMap, stowAssociateMetricsMap, plannedPackageMetricsMap
        } = this.props;
        const defaultMetricValue = "-"
        const routeCode = plannedPackageMetricsMap[routeId].routeCode;

        return {
            routeCode: routeCode,
            plannedPackages: chainWalk(() => stowPackageMetricsMap[routeId].plannedPackages, defaultMetricValue),
            receivedPackages: chainWalk(() => inductPackageMetricsMap[routeId].receivedPackages, defaultMetricValue),
            currentInductedPackages: chainWalk(() => stowPackageMetricsMap[routeId].currentInductedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[routeId].stowedPackages, defaultMetricValue),
            stowVsPlan: chainWalk(() => stowPackageMetricsMap[routeId].stowVsPlan, defaultMetricValue),
            problemSolvePackages: chainWalk(() => stowPackageMetricsMap[routeId].problemSolvePackages, defaultMetricValue),
            fsaf: chainWalk(() => stowPackageMetricsMap[routeId].fsaf, defaultMetricValue),
            stowRate: chainWalk(() => stowPackageMetricsMap[routeId].stowRate, defaultMetricValue),
            scanCompliance: chainWalk(() => stowPackageMetricsMap[routeId].scanCompliance, defaultMetricValue),
            activeStowers: chainWalk(() => stowAssociateMetricsMap[routeCode].activeStowers, 0),
            inactiveStowers: chainWalk(() => stowAssociateMetricsMap[routeCode].inactiveStowers, 0)
        }
    }

    renderClickableCount = (value, state, routeId = null) => {
        const params = this.createParams(state, routeId);

        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(params)}
                  type="secondary"> {value} </Link> : value
    }

    onRouteClick = (routeId, routeCode) => {
        const nodeId = getNodeId();
        getDocumentURL().then(result => {
            const params = [
                "Stow",
                routeId,
                NOT_AVAILABLE,
                NOT_AVAILABLE,
                NOT_AVAILABLE,
                NOT_AVAILABLE,
                routeCode,
                nodeId,
            ]
            const url = new URL(result.replace("stow", "pick"));
            const shareableLink = "/routeDetail/" + params.join("/");
            url.searchParams.set("shareableLink", shareableLink);
            window.open(url.href, "_parent")
        });
    }


    createParams = (state, routeId) => {
        const params = {
            PACKAGE_STATUS: state,
        }

        if (!routeId) {
            params["DRS"] = "TRUE";
        } else {
            params["ROUTE_ID"] = routeId;
        }

        return params;
    }

    getPackageListURL = (params) => {
        return "#packageList/?" + formQueryParams(params);
    }
}

const mapStateToProps = state => ({
    loading: state.routeReducer.loading,
    stowPackageMetricsMap: state.routeReducer.stowPackageMetricsMap,
    plannedPackageMetricsMap: state.routeReducer.plannedPackageMetricsMap,
    inductPackageMetricsMap: state.routeReducer.inductPackageMetricsMap,
    stowAssociateMetricsMap: state.routeReducer.stowAssociateMetricsMap,
    capability: state.optionsReducer.capability
});
export default withRouter(connect(mapStateToProps)(Route));



// WEBPACK FOOTER //
// ./src/components/Route.js